import './styles.scss'
import React from 'react'
import { I18n } from 'react-redux-i18n'

import { DotsOptionsSelector } from 'components/common'
import ActionsView from '../ActionsView'
import { getParsedActionDetail } from 'components/SmartChatView/utils'

const ActionCardUI = ({ actionDetail, modalActionRef, actionType, actionData, dataWay, isOpenOptions, toggleIsOpenOptions, handleActionModal, handleDeleteActionModal }) => (
  <div
    className={`
      action-card
      ${actionDetail.actionType || 'botAction'}
      ${['eventReassignConversation', 'reassignConversation', 'FAQ'].includes(actionDetail.actionSubtype) ? 'action-card--fit-content' : ''}
    `}
  >
    <div className='action-card__header'>
      <strong className='action-card__title text-ellipsis'>
        {I18n.t(`smartchat_actions_${getParsedActionDetail({ mode: 'revert', actionDetail }).eventType}`)}
      </strong>
      <DotsOptionsSelector
        isOpen={isOpenOptions}
        toggle={toggleIsOpenOptions}
        options={[
          {
            name: I18n.t('dashboard_edit'),
            onClick: handleActionModal
          },
          {
            name: I18n.t('dashboard_delete'),
            onClick: handleDeleteActionModal
          }
        ]}
        position='top'
      />
    </div>
    <div className='action-card__body'>
      <ActionsView
        renderType='preview'
        previewActionDetail={actionDetail}
        previewActionRef={modalActionRef}
        actionType={actionType}
        currentValue={actionData}
        dataWay={dataWay}
      />
    </div>
  </div>
)

export default ActionCardUI
